module.exports = __webpack_public_path__ + "static/media/redCircleSalesSvg.66284cd7.svg";